/* -------------------------------------------------------------------------- */
/*                               Modal                               */
/* -------------------------------------------------------------------------- */

const modalInit = () => {
  const { getData, getItemFromStore } = window.phoenix.utils;
  const $modals = document.querySelectorAll('[data-phoenix-modal]');

  if ($modals) {
    $modals.forEach(modal => {
      modal.addEventListener('shown.bs.modal', () => {
        console.log('jasdhsd');
        const $autofocusEls = modal.querySelectorAll('[autofocus=autofocus]');
        $autofocusEls.forEach(el => {
          el.focus();
        });
      });
    });
  }
};
export default modalInit;
